import { render } from "./StudyResultedu.vue?vue&type=template&id=5c810b58"
import script from "./StudyResultedu.vue?vue&type=script&lang=js"
export * from "./StudyResultedu.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/StudyResultedu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c810b58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c810b58', __exports__)) {
    api.reload('5c810b58', __exports__)
  }
  
  module.hot.accept("./StudyResultedu.vue?vue&type=template&id=5c810b58", () => {
    api.rerender('5c810b58', render)
  })

}


export default __exports__